import translate_en from './en.json';
import translate_es from './es.json';
import translate_id from './id.json';
import translate_pt from './pt.json';

export const LOCALE_CODE = {
    en: 'en',
    es: 'es',
    id: 'id',
    pt: 'pt',
};

export const normalizeLocaleCode = (code) => {
    const normalized = (code || LOCALE_CODE.en).toLowerCase();

    if (normalized === LOCALE_CODE.es) {
        return LOCALE_CODE.es;
    }

    if (normalized === LOCALE_CODE.pt) {
        return LOCALE_CODE.pt;
    }

    if (normalized === LOCALE_CODE.id) {
        return LOCALE_CODE.id;
    }

    return LOCALE_CODE.en;
};

export const getLangByLocaleCode = (code) => {
    switch (normalizeLocaleCode(code)) {
        case LOCALE_CODE.es:
            return translate_es;
        case LOCALE_CODE.id:
            return translate_id;
        case LOCALE_CODE.pt:
            return translate_pt;
        case LOCALE_CODE.en:
        default:
            return translate_en;
    }
};

export const AVAILABLE_LOCALES = [
    { value: LOCALE_CODE.en, name: 'EN', fullName: 'English' },
    { value: LOCALE_CODE.es, name: 'ES', fullName: 'Español' },
    { value: LOCALE_CODE.pt, name: 'PT', fullName: 'Português' },
    { value: LOCALE_CODE.id, name: 'ID', fullName: 'Bahasa Indonesia' },
];
